module.exports = __webpack_public_path__ + "img/jiadu.e08cbab6.png";